module.exports = __webpack_public_path__ + "static/generetavi_01-8f70476e7861464027f4ada0752d467c.webp";